import { RouteControlType } from './route-control-type';
import { Expose } from 'class-transformer';
import { VehicleReport } from './vehicle-report';

export class RouteControlReport extends VehicleReport {
  @Expose({ name: 'event_type' })
  eventType: RouteControlType;
}
